module.exports = __webpack_public_path__ + "static/media/revolver.25251236.svg";